import React, { createContext, useContext, useState, useCallback, useMemo, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import TcSDK from '3cplusv2-sdk-js';
import { io } from 'socket.io-client';
import { SipProvider, SIP_STATUS_ERROR, SIP_STATUS_REGISTERED, SIP_STATUS_CONNECTED, sipPropType, callPropType } from 'react-sip';
import { FaPhone, FaBars, FaCopy, FaPaste, FaBackspace } from 'react-icons/fa';
import InputMask from 'react-input-mask';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var API_URL = 'https://app.3c.fluxoti.com';
var SOCKET_URL = 'https://socket.3c.fluxoti.com';

var AGENT_STATUS;

(function (AGENT_STATUS) {
  AGENT_STATUS[AGENT_STATUS["DISCONNECTED"] = -1] = "DISCONNECTED";
  AGENT_STATUS[AGENT_STATUS["CONNECTED"] = 0] = "CONNECTED";
  AGENT_STATUS[AGENT_STATUS["IDLE"] = 1] = "IDLE";
  AGENT_STATUS[AGENT_STATUS["ACW"] = 2] = "ACW";
  AGENT_STATUS[AGENT_STATUS["MANUAL"] = 4] = "MANUAL";
  AGENT_STATUS[AGENT_STATUS["ON_CALL"] = 5] = "ON_CALL";
  AGENT_STATUS[AGENT_STATUS["ON_HOLD"] = 6] = "ON_HOLD";
  AGENT_STATUS[AGENT_STATUS["AGENT_BREAK"] = 10] = "AGENT_BREAK";
  AGENT_STATUS[AGENT_STATUS["ERROR"] = 99] = "ERROR";
})(AGENT_STATUS || (AGENT_STATUS = {}));

var WS_AGENT_EVENTS_MAP = {
  'agent-is-disconnected': {
    status: AGENT_STATUS.DISCONNECTED,
    label: 'Desconectado'
  },
  'agent-is-connected': {
    status: AGENT_STATUS.CONNECTED,
    label: 'Conectado'
  },
  'agent-login-failed': {
    status: AGENT_STATUS.DISCONNECTED,
    label: 'Falha ao logar...'
  },
  'agent-was-logged-out': {
    status: AGENT_STATUS.DISCONNECTED,
    label: 'Deslogado'
  },
  'agent-is-idle': {
    status: AGENT_STATUS.IDLE,
    label: 'Disponível'
  },
  'agent-in-acw': {
    status: AGENT_STATUS.ACW,
    label: 'Pós atendimento'
  },
  'agent-entered-manual': {
    status: AGENT_STATUS.MANUAL,
    label: 'Modo manual'
  },
  'agent-failed-to-enter-manual': {
    status: AGENT_STATUS.ERROR,
    label: 'Falha em modo manual'
  },
  'agent-left-manual-mode': {
    status: AGENT_STATUS.CONNECTED,
    label: 'Saiu do modo manual'
  },
  'agent-failed-to-leave-manual-mode': {
    status: AGENT_STATUS.ERROR,
    label: 'Falha ao sair do modo manual'
  },
  'agent-entered-manual-acw': {
    status: AGENT_STATUS.ACW,
    label: 'Pós atendimento (manual)'
  },
  'agent-left-manual-acw': {
    status: AGENT_STATUS.CONNECTED,
    label: 'Saiu do pós atendimento (manual)'
  },
  'agent-entered-work-break': {
    status: AGENT_STATUS.AGENT_BREAK,
    label: 'Em intervalo...'
  },
  'agent-enter-work-break-failed': {
    status: AGENT_STATUS.ERROR,
    label: 'Falha ao entrar em intervalo'
  },
  'agent-leave-work-break-failed': {
    status: AGENT_STATUS.ERROR,
    label: 'Falha ao sair do intervalo'
  },
  'agent-schedule': {
    status: AGENT_STATUS.CONNECTED,
    label: 'Agendamento'
  }
};

var CALL_STATUS;

(function (CALL_STATUS) {
  CALL_STATUS[CALL_STATUS["DISCONNECTED"] = -1] = "DISCONNECTED";
  CALL_STATUS[CALL_STATUS["ON_CALL"] = 1] = "ON_CALL";
  CALL_STATUS[CALL_STATUS["ON_CONSULT"] = 2] = "ON_CONSULT";
  CALL_STATUS[CALL_STATUS["ON_HOLD"] = 3] = "ON_HOLD";
  CALL_STATUS[CALL_STATUS["FINISHED"] = 4] = "FINISHED";
  CALL_STATUS[CALL_STATUS["ERROR"] = 99] = "ERROR";
})(CALL_STATUS || (CALL_STATUS = {}));

var WS_CALL_EVENTS_MAP = {
  'call-is-disconnected': {
    status: CALL_STATUS.DISCONNECTED,
    label: 'Desconectada'
  },
  'call-was-created': {
    status: CALL_STATUS.ON_CALL,
    label: 'Criada'
  },
  'call-was-answered': {
    status: CALL_STATUS.ON_CALL,
    label: 'Atendida'
  },
  'call-was-connected': {
    status: CALL_STATUS.ON_CALL,
    label: 'Conectada'
  },
  'call-was-ended': {
    status: CALL_STATUS.FINISHED,
    label: 'Encerrada'
  },
  'call-was-finished': {
    status: CALL_STATUS.FINISHED,
    label: 'Finalizada'
  },
  'call-was-abandoned': {
    status: CALL_STATUS.FINISHED,
    label: 'Abandonada'
  },
  'call-was-abandoned-due-amd': {
    status: CALL_STATUS.FINISHED,
    label: 'Abandonada (AMD)'
  },
  'call-was-not-answered': {
    status: CALL_STATUS.FINISHED,
    label: 'Não atendida'
  },
  'call-was-failed': {
    status: CALL_STATUS.ERROR,
    label: 'Falhou'
  },
  'manual-call-was-answered': {
    label: 'Atendida (manual)',
    status: CALL_STATUS.ON_CALL
  },
  'manual-call-acw-connected': {
    status: CALL_STATUS.ON_CALL,
    label: 'Pós atendimento (manual)'
  },
  'manual-call-acw-disconnected': {
    status: CALL_STATUS.FINISHED,
    label: 'Pós atendimento desconectado'
  },
  'hold-call': {
    status: CALL_STATUS.ON_HOLD,
    label: 'Pausada'
  },
  'consult-connected': {
    status: CALL_STATUS.ON_CONSULT,
    label: 'Consulta conectada'
  },
  'consult-cancel-hold': {
    status: CALL_STATUS.ON_CALL,
    label: 'Espera cancelada'
  },
  'consult-exit': {
    status: CALL_STATUS.ON_CALL,
    label: 'Fim da consulta'
  },
  'consult-hold': {
    status: CALL_STATUS.ON_HOLD,
    label: 'Em espera'
  }
};

var VALID_CELL_LENGTH = 11;
var VALID_TELEPHONE_LENGTH = 10;
var PHONE_PREFIX = '9';
var DDD_LENGTH = 2;
var DDI_LENGTH = 2;

var _excluded = ["children"];
/**
 * Voip Context.
 *
 * ```tsx
 * const {
 *   voipApi,
 *   voipSocket,
 *   agentStatus,
 *   callStatus,
 * } = React.useContext(VoipContext);
 * ```
 */

var VoipContext = /*#__PURE__*/createContext(undefined);
/**
 * Custom hook that ensure the voip context exists.
 *
 * @returns {VoipContextInterface} Voip context.
 */

var useVoipContext = function useVoipContext() {
  var context = useContext(VoipContext);

  if (!context) {
    throw new Error('useVoipContext must be used within VoipProvider');
  }

  return context;
};
/* Voip Provider */


var VoipProvider = function VoipProvider(_ref, context) {
  var auth = _ref.auth,
      children = _ref.children,
      agentToken = _ref.agentToken,
      setSipAuth = _ref.setSipAuth,
      _ref$logWSEvents = _ref.logWSEvents,
      logWSEvents = _ref$logWSEvents === void 0 ? false : _ref$logWSEvents;

  /* API context value */
  var _useState = useState(),
      voipApi = _useState[0],
      setVoipApi = _useState[1];
  /* Socket context value */


  var _useState2 = useState(),
      voipSocket = _useState2[0],
      setVoipSocket = _useState2[1];
  /* Agent status value */


  var _useState3 = useState(WS_AGENT_EVENTS_MAP['agent-is-disconnected']),
      agentStatus = _useState3[0],
      setAgentStatus = _useState3[1];
  /* Call status value */


  var _useState4 = useState(WS_CALL_EVENTS_MAP['call-is-disconnected']),
      callStatus = _useState4[0],
      setCallStatus = _useState4[1];
  /* SIP error status */


  var _useState5 = useState(false),
      sipError = _useState5[0],
      setSipError = _useState5[1];
  /* Initialize all providers values */


  useEffect(function () {
    if (!agentToken) {
      handleLogout();
      return;
    }
    /* API initialization */


    var apiInstance = new TcSDK({
      baseURL: API_URL
    }).v1().withAuth(agentToken);
    /* Socket initialization */

    var socketInstance = io(SOCKET_URL, {
      transports: ['websocket'],
      query: {
        token: agentToken
      }
    });
    socketInstance.onAny(handleWebSocketEvent);
    /* Sets provider values */

    setVoipApi(apiInstance);
    setVoipSocket(socketInstance);
  }, [agentToken]);
  /* After the api initialization, grabs the sip user and password */

  useEffect(function () {
    if (!voipApi) {
      return;
    }

    voipApi.user().me().then(function (response) {
      var _response$data$data = response.data.data,
          telephony_id = _response$data$data.telephony_id,
          extension_password = _response$data$data.extension_password;
      setSipAuth({
        user: telephony_id,
        password: extension_password
      });
    })["catch"](function (err) {
      return console.error(err);
    });
  }, [voipApi]);
  /* Handles SIP status changes */

  useEffect(function () {
    if (!agentToken) {
      return;
    }

    switch (context.sip.status) {
      case SIP_STATUS_CONNECTED:
        context.registerSip();
        break;

      case SIP_STATUS_REGISTERED:
        authenticateAgent();
        break;

      case SIP_STATUS_ERROR:
        setSipError(true);
        setTimeout(function () {
          window.location.reload();
        }, 60 * 1000);
        console.error('SIP Error:', context.sip.errorType);
        break;
    }
  }, [agentToken, context.sip.status]);
  /* Registers socket listeners to change voip status */

  useEffect(function () {
    if (!voipSocket) {
      return;
    }
    /* Agent status changes */


    var agentEventsMap = Object.entries(WS_AGENT_EVENTS_MAP);

    var _loop = function _loop() {
      var _agentEventsMap$_i = _agentEventsMap[_i],
          eventName = _agentEventsMap$_i[0],
          agentStatusMapped = _agentEventsMap$_i[1];
      voipSocket.on(eventName, function () {
        setAgentStatus(agentStatusMapped);
      });
    };

    for (var _i = 0, _agentEventsMap = agentEventsMap; _i < _agentEventsMap.length; _i++) {
      _loop();
    }
    /* Call status changes */


    var callEventsMap = Object.entries(WS_CALL_EVENTS_MAP);

    var _loop2 = function _loop2() {
      var _callEventsMap$_i = _callEventsMap[_i2],
          eventName = _callEventsMap$_i[0],
          callStatusMapped = _callEventsMap$_i[1];
      voipSocket.on(eventName, function () {
        setCallStatus(callStatusMapped);
      });
    };

    for (var _i2 = 0, _callEventsMap = callEventsMap; _i2 < _callEventsMap.length; _i2++) {
      _loop2();
    }

    voipSocket.on('agent-left-manual', function () {
      setCallStatus(WS_CALL_EVENTS_MAP['call-was-finished']);
    });
  }, [voipSocket]);
  /**
   * Connect to WebSocket server and log agent in a campaign.
   */

  var authenticateAgent = useCallback(function () {
    if (!voipSocket || !voipApi) {
      return;
    }

    var listener = function listener() {
      voipSocket.off('agent-is-connected', listener);
      voipApi.agent().login({
        campaign: auth.campaign,
        mode: auth.mode
      })["catch"](function (err) {
        return console.error(err);
      });
    };

    voipSocket.on('agent-is-connected', listener);
    console.log('Connecting agent...');
    voipApi.agent().connect();
  }, [voipSocket, voipApi]);
  /**
   * Handles agent token logout.
   */

  var handleLogout = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!voipApi) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return voipApi.agent().logout();

          case 3:
            setVoipApi(undefined);

          case 4:
            if (voipSocket) {
              voipSocket.once('agent-was-logged-out', function () {
                voipSocket.offAny();
                voipSocket.disconnect();
                setVoipSocket(undefined);
              });
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [voipApi, voipSocket]);
  /**
   * Generic web socket event handler.
   *
   * @param {string} event WebSocket event name.
   * @param {Record<string, unknown>} payload Events payload.
   */

  var handleWebSocketEvent = function handleWebSocketEvent(event, payload) {
    if (logWSEvents) {
      console.group('VOIP WebSocket Event');
      console.log('name:', event);
      console.log('payload:', payload);
      console.groupEnd();
    }
  };

  return React.createElement(VoipContext.Provider, {
    value: {
      auth: auth,
      sipError: sipError,
      voipApi: voipApi,
      voipSocket: voipSocket,
      agentStatus: agentStatus,
      callStatus: callStatus
    }
  }, children);
};
/* Receiving VoipProvider context declaration */


VoipProvider.contextTypes = {
  sip: sipPropType,
  call: callPropType,
  registerSip: PropTypes.func,
  unregisterSip: PropTypes.func,
  answerCall: PropTypes.func,
  startCall: PropTypes.func,
  stopCall: PropTypes.func
};
/**
 * Makes `voipApi`, `voipSocket` and `voipStatus` accessible throughout
 * the application component tree bellow it via `React.useContext`.
 */

var Provider = function Provider(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  /* SIP user authentication data */
  var _useState6 = useState({
    user: undefined,
    password: undefined
  }),
      sipAuth = _useState6[0],
      setSipAuth = _useState6[1];
  /**
   * Generates sip config.
   *
   * @param {string | undefined} user SIP user.
   * @param {string | undefined} password SIP password.
   */


  var sipProviderConfigGenerator = useCallback(function (user, password) {
    return {
      user: user,
      password: password,
      host: "sintonia.3c.fluxoti.com",
      port: 4443,
      autoRegister: false,
      autoAnswer: true,
      iceRestart: true,
      sessionTimersExpires: 120,
      debug: false
    };
  }, []);
  /* SIP dynamic config object */

  var sipConfig = useMemo(function () {
    return sipProviderConfigGenerator(sipAuth.user, sipAuth.password);
  }, [sipAuth]);
  return React.createElement(SipProvider, Object.assign({}, sipConfig), React.createElement(VoipProvider, Object.assign({
    setSipAuth: setSipAuth
  }, props), children));
};

/* Phone loading reducer initial state */
var loadingInitialState = {
  acw: false,
  auth: false,
  calling: false,
  hangingUp: false,
  manualMode: false,
  consulting: false,
  transferring: false,
  transferList: true,
  workBreakList: false
};
/**
 * Reducer for handling phone loading states.
 *
 * @param {PhoneLoadingInterface} state Loading reducer current state.
 * @param {PhoneLoadingAction} action Dispatched action.
 * @returns {PhoneLoadingInterface} New loading state.
 */

function loadingReducer(state, action) {
  switch (action.type) {
    /* Auth */
    case 'auth-loading':
      return _extends({}, state, {
        auth: true
      });

    case 'auth-success':
    case 'auth-fail':
      return _extends({}, state, {
        auth: false
      });

    /* Manual Mode */

    case 'manualMode-loading':
      return _extends({}, state, {
        manualMode: true
      });

    case 'manualMode-success':
    case 'manualMode-fail':
      return _extends({}, state, {
        manualMode: false
      });

    /* Calling */

    case 'calling-loading':
      return _extends({}, state, {
        calling: true
      });

    case 'calling-success':
    case 'calling-fail':
      return _extends({}, state, {
        calling: false
      });

    /* Consulting */

    case 'consulting-loading':
      return _extends({}, state, {
        consulting: true
      });

    case 'consulting-success':
    case 'consulting-fail':
      return _extends({}, state, {
        consulting: false
      });

    /* Transferring */

    case 'transferring-loading':
      return _extends({}, state, {
        transferring: true
      });

    case 'transferring-success':
    case 'transferring-fail':
      return _extends({}, state, {
        transferring: false
      });

    /* Hanging Up */

    case 'hangingUp-loading':
      return _extends({}, state, {
        hangingUp: true
      });

    case 'hangingUp-success':
    case 'hangingUp-fail':
      return _extends({}, state, {
        hangingUp: false
      });

    /* Transfer List */

    case 'transferList-loading':
      return _extends({}, state, {
        transferList: true
      });

    case 'transferList-success':
    case 'transferList-fail':
      return _extends({}, state, {
        transferList: false
      });

    /* Work Break List */

    case 'workBreakList-loading':
      return _extends({}, state, {
        workBreakList: true
      });

    case 'workBreakList-success':
    case 'workBreakList-fail':
      return _extends({}, state, {
        workBreakList: false
      });

    /* ACW */

    case 'acw-loading':
      return _extends({}, state, {
        acw: true
      });

    case 'acw-success':
    case 'acw-fail':
      return _extends({}, state, {
        acw: false
      });

    default:
      throw new Error("Action: " + action.type + " is not valid.");
  }
}

var MAX_INPUT_LENGTH = 11;
/**
 * Phone context.
 */

var PhoneContext = /*#__PURE__*/createContext(undefined);
/**
 * Custom hook that ensure the phone context exists.
 *
 * @returns {PhoneContextInterface} Phone context.
 */

var usePhoneContext = function usePhoneContext() {
  var context = useContext(PhoneContext);

  if (!context) {
    throw new Error('usePhoneContext must be used within PhoneProvider');
  }

  return context;
};

var PhoneProvider = function PhoneProvider(_ref) {
  var children = _ref.children;

  /* Voip context */
  var _useVoipContext = useVoipContext(),
      auth = _useVoipContext.auth,
      voipApi = _useVoipContext.voipApi,
      voipSocket = _useVoipContext.voipSocket,
      agentStatus = _useVoipContext.agentStatus;
  /* Phone number value */


  var _useState = useState(''),
      value = _useState[0],
      setValue = _useState[1];
  /* Campaign name value */


  var _useState2 = useState(''),
      campaignName = _useState2[0],
      setCampaignName = _useState2[1];
  /* Input focus status */


  var _useState3 = useState(false),
      focus = _useState3[0],
      setFocus = _useState3[1];
  /* Hold the value that represents if the phone is open or not */


  var _useState4 = useState(false),
      open = _useState4[0],
      setOpen = _useState4[1];
  /* Menu status, open or close */


  var _useState5 = useState(false),
      menu = _useState5[0],
      setMenu = _useState5[1];
  /* Transfer menu status, open or close */


  var _useState6 = useState(false),
      transferMenu = _useState6[0],
      setTransferMenu = _useState6[1];
  /* Transfer menu status, open or close */


  var _useState7 = useState(false),
      workBreakMenu = _useState7[0],
      setWorkBreakMenu = _useState7[1];
  /* Hold the call id value */


  var _useState8 = useState(),
      callId = _useState8[0],
      setCallId = _useState8[1];
  /* Agents available list */


  var _useState9 = useState([]),
      agentsAvailable = _useState9[0],
      setAgentsAvailable = _useState9[1];
  /* Queues available list */


  var _useState10 = useState([]),
      queuesAvailable = _useState10[0],
      setQueuesAvailable = _useState10[1];
  /* Consulted agent ID */


  var _useState11 = useState(),
      consultedAgentId = _useState11[0],
      setConsultedAgentId = _useState11[1];
  /* Consulted queue ID */


  var _useState12 = useState(),
      consultedQueueId = _useState12[0],
      setConsultedQueueId = _useState12[1];
  /* If the consulted queue is on hold */


  var _useState13 = useState(false),
      onHold = _useState13[0],
      setOnHold = _useState13[1];
  /* If the agent is connected to a consult */


  var _useState14 = useState(false),
      consulting = _useState14[0],
      setConsulting = _useState14[1];
  /* Work breaks available list */


  var _useState15 = useState([]),
      workBreaksAvailable = _useState15[0],
      setWorkBreaksAvailable = _useState15[1];
  /* Work breaks that already reached maximum time limit */


  var _useState16 = useState([]),
      workBreaksLimitReachedIds = _useState16[0],
      setWorkBreaksLimitReachedIds = _useState16[1];
  /* Loading reducer */


  var _useReducer = useReducer(loadingReducer, loadingInitialState),
      loading = _useReducer[0],
      dispatchLoadingAction = _useReducer[1];
  /* Resolves if the phone is on a call */


  var onCall = useMemo(function () {
    return Boolean(callId);
  }, [callId]);
  /* Resolves if the value is a cellphone number */

  var isCellphone = useMemo(function () {
    return value.startsWith(PHONE_PREFIX, DDD_LENGTH);
  }, [value]);
  /* Resolves if the value is a valid phone number */

  var validPhone = useMemo(function () {
    /* Cellphone check */
    if (isCellphone && value.length === VALID_CELL_LENGTH) {
      return true;
    }
    /* Telephone check */


    if (value.length === VALID_TELEPHONE_LENGTH) {
      return true;
    }

    return false;
  }, [value, isCellphone]);
  /* Represents if the call is on a consult */

  var onConsult = useMemo(function () {
    return Boolean(consultedAgentId) || Boolean(consultedQueueId);
  }, [consultedAgentId, consultedQueueId]);
  /* Closes menu when phone is closed */

  useEffect(function () {
    if (!open) {
      setMenu(false);
    }
  }, [open]);
  /* Closes transfer menu when menu is closed */

  useEffect(function () {
    if (!menu) {
      setTransferMenu(false);
    }
  }, [menu]);
  /* Closes work break menu when menu is closed */

  useEffect(function () {
    if (!menu) {
      setWorkBreakMenu(false);
    }
  }, [menu]);
  /* Loads all agents and queues available every time the transfer menu is open */

  useEffect(function () {
    if (voipApi && transferMenu) {
      loadAvailableTransferList();
    }
  }, [voipApi, transferMenu]);
  /* Keydown event listener */

  useEffect(function () {
    if (open && focus) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, focus]);
  /* Register socket events */

  useEffect(function () {
    if (!voipSocket) {
      return;
    }

    var setHoldToFalse = function setHoldToFalse() {
      return setOnHold(false);
    };
    /* Handles call connected */


    voipSocket.on('call-was-connected', function (event) {
      var phone = event.call.phone;

      if (phone.length === MAX_INPUT_LENGTH) {
        setValue(phone);
      } else if (phone.length === MAX_INPUT_LENGTH + DDI_LENGTH || phone.length === VALID_TELEPHONE_LENGTH + DDI_LENGTH) {
        setValue(phone.substring(2));
      }

      setConsulting(false);
      setConsultedAgentId(undefined);
      setConsultedQueueId(undefined);
      setCallId(event.call.id);
    });
    /* Handles ending manual call */

    voipSocket.on('agent-is-idle', function (event) {
      if (event.agent.status === AGENT_STATUS.MANUAL) {
        dispatchLoadingAction({
          type: 'hangingUp-success'
        });
        handleExitManualMode();
      }

      voipApi.client.get('/agent/loggedCampaign').then(function (res) {
        setCampaignName(res.data.data.name);
      });
      setValue('');
      setConsulting(false);
      setCallId(undefined);
    });
    /* Handles canceling a consult */

    voipSocket.on('consult-cancel-hold', setHoldToFalse);
    voipSocket.on('consult-exit', function () {
      setConsulting(false);
      setHoldToFalse();
    });
    /* Handles entering a consult */

    voipSocket.on('consult-connected', function (event) {
      setConsultedAgentId(event.agent.id);
      setConsulting(true);
      setHoldToFalse();
    });
    /* Handles when a consult is on hold */

    voipSocket.on('consult-hold', function () {
      setOnHold(true);
    });
    /* Handles when an agent enters an interval */

    voipSocket.on('agent-entered-work-break', function () {
      dispatchLoadingAction({
        type: 'workBreakList-success'
      });
    });
    /* Handles when an agent fails entering an interval */

    voipSocket.on('agent-enter-work-break-failed', function () {
      dispatchLoadingAction({
        type: 'workBreakList-fail'
      });
    });
    /* Handles when an agent exits an interval */

    voipSocket.on('agent-left-work-break', function () {
      dispatchLoadingAction({
        type: 'workBreakList-success'
      });
    });
    /* Handles when an agent fails exiting an interval */

    voipSocket.on('agent-leave-work-break-failed', function () {
      dispatchLoadingAction({
        type: 'workBreakList-fail'
      });
    });
  }, [voipSocket]);
  /**
   * Handles keyboard key press.
   *
   * @param {KeyboardEvent} event Default keyboard event.
   */

  var handleKeyDown = useCallback(function (event) {
    if (!open) {
      return;
    }
    /* If the input was a number */


    if (RegExp(/\d/).test(event.key)) {
      var number = parseInt(event.key, 10);
      handleKeyNumberPress(number);
      return;
    }
    /* If the input was the Backspace key */


    if (event.key === 'Backspace') {
      handleEraseNumber();
      return;
    }
    /* If the input was the Enter key */


    if (event.key === 'Enter') {
      handleStartManualCall();
      return;
    }
  }, [open]);
  /**
   * Toggles phone display status.
   */

  var handleTogglePhone = useCallback(function () {
    setOpen(function (state) {
      return !state;
    });
  }, []);
  /**
   * Toggles phone menu.
   */

  var handleToggleMenu = useCallback(function () {
    setMenu(function (state) {
      return !state;
    });
  }, []);
  /**
   * Toggles transfer menu status.
   */

  var handleToggleTransferMenu = useCallback(function () {
    setTransferMenu(function (state) {
      return !state;
    });
  }, []);
  /**
   * Toggles work break menu status.
   */

  var handleToggleWorkBreakMenu = useCallback(function () {
    setWorkBreakMenu(function (state) {
      return !state;
    });
  }, []);
  /**
   * Adds a new number to phone numbers value.
   *
   * @param {number} number New number to be add.
   */

  var handleKeyNumberPress = useCallback(function (number) {
    setValue(function (state) {
      if (state.length === MAX_INPUT_LENGTH) {
        return state;
      }

      return state + number.toString();
    });
  }, []);
  /**
   * Parse and set to value the number from the navigator clipboard.
   */

  var handlePasteNumber = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var textFromClipboard, parsedText;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (navigator) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return navigator.clipboard.readText();

          case 4:
            textFromClipboard = _context.sent;
            parsedText = textFromClipboard.replace(/\D/g, '').substring(0, MAX_INPUT_LENGTH);
            setValue(parsedText);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  /**
   * Erases the last number in phone numbers value.
   */

  var handleEraseNumber = useCallback(function () {
    setValue(function (state) {
      if (state.length === 0) {
        return state;
      }

      return state.slice(0, state.length - 1);
    });
  }, []);
  /**
   * Handles login in an agent.
   */

  var handleLoginAgent = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!voipApi || !voipSocket)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'auth-loading'
            });
            _context2.next = 5;
            return voipApi.agent().login({
              campaign: auth.campaign,
              mode: auth.mode
            }).then(function () {
              voipSocket.once('agent-is-idle', function () {
                dispatchLoadingAction({
                  type: 'auth-success'
                });
              });
            })["catch"](function (err) {
              dispatchLoadingAction({
                type: 'auth-fail'
              });
              console.error(err);
            });

          case 5:
            return _context2.abrupt("return");

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [voipApi, voipSocket, auth]);
  /**
   * Handles login out an agent.
   */

  var handleLogoutAgent = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!voipApi || !voipSocket)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'auth-loading'
            });
            _context3.next = 5;
            return voipApi.agent().logout().then(function () {
              voipSocket.once('agent-was-logged-out', function () {
                dispatchLoadingAction({
                  type: 'auth-success'
                });
              });
            })["catch"](function (err) {
              dispatchLoadingAction({
                type: 'auth-fail'
              });
              console.error(err);
            });

          case 5:
            return _context3.abrupt("return");

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [voipApi, voipSocket]);
  /**
   * Hangs up active call.
   */

  var handleHangupCall = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4() {
    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!voipApi || !voipSocket || !callId || agentStatus.status === AGENT_STATUS.ACW || loading.hangingUp)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'hangingUp-loading'
            });
            _context4.next = 5;
            return voipApi.agent().hangupCall(callId).then(function () {
              voipSocket.once('call-was-finished', function () {
                dispatchLoadingAction({
                  type: 'hangingUp-success'
                });
              });
            })["catch"](function () {
              dispatchLoadingAction({
                type: 'hangingUp-fail'
              });
            });

          case 5:
            return _context4.abrupt("return");

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [voipApi, voipSocket, callId, agentStatus.status, loading.hangingUp]);
  /**
   * Sends an api call finishing the last call.
   */

  var handleQualifyCall = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5() {
    return runtime_1.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!voipApi || !callId)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'acw-loading'
            });
            _context5.next = 5;
            return voipApi.agent().qualifyCall(callId, {
              qualification_id: 10777
            }).then(function () {
              dispatchLoadingAction({
                type: 'acw-success'
              });
            })["catch"](function () {
              dispatchLoadingAction({
                type: 'acw-fail'
              });
            })["finally"](function () {
              setCallId(undefined);
              setValue('');
            });

          case 5:
            return _context5.abrupt("return");

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })), [voipApi, callId]);
  /**
   * Calls api to enter manual call mode.
   */

  var handleEnterManualMode = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6() {
    return runtime_1.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (voipApi) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'manualMode-loading'
            });
            _context6.next = 5;
            return voipApi.agent().enterManualCallMode().then(function () {
              dispatchLoadingAction({
                type: 'manualMode-success'
              });
            })["catch"](function () {
              dispatchLoadingAction({
                type: 'manualMode-fail'
              });
            });

          case 5:
            return _context6.abrupt("return");

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), [voipApi]);
  /**
   * Calls api to enter manual call mode.
   */

  var handleExitManualMode = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7() {
    return runtime_1.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (voipApi) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'manualMode-loading'
            });
            _context7.next = 5;
            return voipApi.agent().exitManualCallMode().then(function () {
              dispatchLoadingAction({
                type: 'manualMode-success'
              });
            })["catch"](function () {
              dispatchLoadingAction({
                type: 'manualMode-fail'
              });
            });

          case 5:
            return _context7.abrupt("return");

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [voipApi]);
  /**
   * Calls api to dial to a number.
   */

  var handleStartManualCall = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8() {
    return runtime_1.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(!voipApi || !voipSocket || !validPhone)) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'calling-loading'
            });
            _context8.next = 5;
            return handleEnterManualMode();

          case 5:
            voipApi.agent().dialManualCall({
              phone: value
            }).then(function () {
              voipSocket.once('call-was-connected', function () {
                dispatchLoadingAction({
                  type: 'calling-success'
                });
              });
            })["catch"](function () {
              dispatchLoadingAction({
                type: 'calling-fail'
              });
            });
            return _context8.abrupt("return");

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })), [voipApi, voipSocket, validPhone, value]);
  /**
   * Calls the api to retrieve all the agents and queues available.
   */

  var loadAvailableTransferList = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9() {
    var _yield$Promise$all, agentsOnlineResponse, queuesAvailableResponse;

    return runtime_1.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (voipApi) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            dispatchLoadingAction({
              type: 'transferList-loading'
            });
            _context9.next = 5;
            return Promise.all([voipApi.client.get('/agents/online'), voipApi.client.get('/receptive_queues/online')]);

          case 5:
            _yield$Promise$all = _context9.sent;
            agentsOnlineResponse = _yield$Promise$all[0];
            queuesAvailableResponse = _yield$Promise$all[1];
            setAgentsAvailable(agentsOnlineResponse.data.data);
            setQueuesAvailable(queuesAvailableResponse.data.data);
            dispatchLoadingAction({
              type: 'transferList-success'
            });
            return _context9.abrupt("return");

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })), [voipApi]);
  /**
   * Starts consulting an agent.
   *
   * @param {number} consultedId Agent ID to be consulted.
   */

  var handleConsultAgent = useCallback( /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee10(consultedId) {
      return runtime_1.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (!(!voipApi || !voipSocket)) {
                _context10.next = 2;
                break;
              }

              return _context10.abrupt("return");

            case 2:
              dispatchLoadingAction({
                type: 'consulting-loading'
              });
              _context10.next = 5;
              return voipApi.client.post('/agent/consult', {
                consultedId: consultedId
              }).then(function () {
                voipSocket.once('consult-connected', function () {
                  dispatchLoadingAction({
                    type: 'consulting-success'
                  });
                });
              })["catch"](function () {
                dispatchLoadingAction({
                  type: 'consulting-fail'
                });
              });

            case 5:
              return _context10.abrupt("return");

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x) {
      return _ref11.apply(this, arguments);
    };
  }(), [voipApi, voipSocket]);
  /**
   * Starts consulting a queue.
   *
   * @param {number} queueId Queue ID to be consulted.
   */

  var handleConsultQueue = useCallback( /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee11(queueId) {
      return runtime_1.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!(!voipApi || !voipSocket)) {
                _context11.next = 2;
                break;
              }

              return _context11.abrupt("return");

            case 2:
              dispatchLoadingAction({
                type: 'consulting-loading'
              });
              _context11.next = 5;
              return voipApi.client.post('/agent/consult/queue', {
                queueId: queueId
              }).then(function () {
                voipSocket.once('consult-connected', function () {
                  dispatchLoadingAction({
                    type: 'consulting-success'
                  });
                });
              })["catch"](function () {
                dispatchLoadingAction({
                  type: 'consulting-fail'
                });
              });

            case 5:
              setConsultedQueueId(queueId);
              return _context11.abrupt("return");

            case 7:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x2) {
      return _ref12.apply(this, arguments);
    };
  }(), [voipApi, voipSocket]);
  /**
   * Transfer call to the consulted agent.
   */

  var handleTransferCall = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee12() {
    return runtime_1.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            dispatchLoadingAction({
              type: 'transferring-loading'
            });
            _context12.next = 3;
            return voipApi.client.post('/agent/consult/transfer', {
              consultedId: consultedAgentId
            }).then(function () {
              dispatchLoadingAction({
                type: 'transferring-success'
              });
            })["catch"](function () {
              dispatchLoadingAction({
                type: 'transferring-fail'
              });
            });

          case 3:
            setConsultedQueueId(undefined);
            setConsultedAgentId(undefined);
            setTransferMenu(false);
            return _context12.abrupt("return");

          case 7:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  })), [voipApi, consultedAgentId]);
  /**
   * Cancels an ongoing consult.
   */

  var handleCancelConsult = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee13() {
    return runtime_1.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!onHold) {
              _context13.next = 5;
              break;
            }

            _context13.next = 3;
            return voipApi.client.post('/agent/consult/cancel');

          case 3:
            _context13.next = 7;
            break;

          case 5:
            _context13.next = 7;
            return voipApi.client.post('/agent/consult/exit');

          case 7:
            dispatchLoadingAction({
              type: 'transferring-success'
            });
            setConsultedAgentId(undefined);
            setConsultedQueueId(undefined);

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  })), [voipApi, onHold]);
  /**
   * Calls api to retrieve all agent work breaks available.
   */

  var handleListWorkBreaks = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee14() {
    var workBreaksAvailableResponse;
    return runtime_1.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            dispatchLoadingAction({
              type: 'workBreakList-loading'
            });
            _context14.next = 3;
            return voipApi.client.get('/agent/work_break_intervals');

          case 3:
            workBreaksAvailableResponse = _context14.sent;
            setWorkBreaksAvailable(workBreaksAvailableResponse.data.data);
            setWorkBreakMenu(true);
            dispatchLoadingAction({
              type: 'workBreakList-success'
            });

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  })), [voipApi]);
  /**
   * Enters agent work break.
   */

  var handleEnterWorkBreak = useCallback(function (id) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee15() {
      return runtime_1.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              dispatchLoadingAction({
                type: 'workBreakList-loading'
              });
              _context15.prev = 1;
              _context15.next = 4;
              return voipApi.client.post("/agent/work_break/" + id + "/enter");

            case 4:
              setWorkBreakMenu(false);
              _context15.next = 11;
              break;

            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15["catch"](1);
              setWorkBreaksLimitReachedIds(function (state) {
                return [].concat(state, [id]);
              });
              dispatchLoadingAction({
                type: 'workBreakList-fail'
              });

            case 11:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[1, 7]]);
    }));
  }, [voipApi]);
  /**
   * Exits agent work break.
   */

  var handleExitWorkBreak = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee16() {
    return runtime_1.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            dispatchLoadingAction({
              type: 'workBreakList-loading'
            });
            _context16.prev = 1;
            _context16.next = 4;
            return voipApi.client.post('/agent/work_break/exit');

          case 4:
            _context16.next = 9;
            break;

          case 6:
            _context16.prev = 6;
            _context16.t0 = _context16["catch"](1);
            dispatchLoadingAction({
              type: 'workBreakList-fail'
            });

          case 9:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[1, 6]]);
  })), [voipApi]);
  return React.createElement(PhoneContext.Provider, {
    value: {
      value: value,
      campaignName: campaignName,
      open: open,
      menu: menu,
      transferMenu: transferMenu,
      workBreakMenu: workBreakMenu,
      callId: callId,
      onHold: onHold,
      onCall: onCall,
      onConsult: onConsult,
      consulting: consulting,
      isCellphone: isCellphone,
      validPhone: validPhone,
      agentsAvailable: agentsAvailable,
      queuesAvailable: queuesAvailable,
      consultedAgentId: consultedAgentId,
      consultedQueueId: consultedQueueId,
      workBreaksAvailable: workBreaksAvailable,
      workBreaksLimitReachedIds: workBreaksLimitReachedIds,
      loading: loading,
      setFocus: setFocus,
      handleLoginAgent: handleLoginAgent,
      handleLogoutAgent: handleLogoutAgent,
      handleTogglePhone: handleTogglePhone,
      handleToggleMenu: handleToggleMenu,
      handleToggleTransferMenu: handleToggleTransferMenu,
      handleToggleWorkBreakMenu: handleToggleWorkBreakMenu,
      handleKeyNumberPress: handleKeyNumberPress,
      handlePasteNumber: handlePasteNumber,
      handleEraseNumber: handleEraseNumber,
      handleStartManualCall: handleStartManualCall,
      handleHangupCall: handleHangupCall,
      handleQualifyCall: handleQualifyCall,
      handleEnterManualMode: handleEnterManualMode,
      handleExitManualMode: handleExitManualMode,
      handleConsultAgent: handleConsultAgent,
      handleConsultQueue: handleConsultQueue,
      handleTransferCall: handleTransferCall,
      handleCancelConsult: handleCancelConsult,
      handleListWorkBreaks: handleListWorkBreaks,
      handleEnterWorkBreak: handleEnterWorkBreak,
      handleExitWorkBreak: handleExitWorkBreak
    }
  }, children);
};

/**
 * Menu button component.
 */

var MenuButton = function MenuButton(_ref) {
  var children = _ref.children,
      loading = _ref.loading,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick;

  /* Resolves menu button class names */
  var className = useMemo(function () {
    var classes = ['voip--phone-menu_item'];

    if (disabled || loading) {
      classes.push('voip--phone-menu_item-disabled');
    }

    return classes.join(' ');
  }, [disabled, loading]);
  /**
   * On button click wrapper function.
   */

  var handleOnClick = useCallback(function () {
    if (disabled || loading) {
      return;
    }

    onClick();
  }, [disabled, loading, onClick]);
  return React.createElement("div", {
    className: className,
    onClick: handleOnClick
  }, loading ? 'Carregando...' : children);
};

/**
 * Transfer menu agent button component.
 */

var TransferMenuAgentButton = function TransferMenuAgentButton(_ref) {
  var agent = _ref.agent,
      disabled = _ref.disabled,
      consultActive = _ref.consultActive,
      onConsult = _ref.onConsult,
      onCancelConsult = _ref.onCancelConsult,
      onTransferConsult = _ref.onTransferConsult;

  /* Resolves class names */
  var className = useMemo(function () {
    var classes = ['voip--phone-menu_item'];

    if (disabled && !consultActive) {
      classes.push('voip--phone-menu_item-disabled');
    }

    if (consultActive) {
      classes.push('voip--phone-menu_item-consult_active');
    }

    return classes.join(' ');
  }, [disabled, consultActive]);
  /**
   * Starts a consulting an agent on click.
   */

  var handleConsultClick = useCallback(function () {
    if (consultActive || disabled) {
      return;
    }

    onConsult(agent.id);
  }, [agent, disabled, consultActive, onConsult]);
  return React.createElement("div", {
    className: className,
    onClick: handleConsultClick
  }, consultActive ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'voip--phone-menu_item-action_cancel',
    onClick: onCancelConsult
  }, "Cancelar"), React.createElement("div", {
    className: 'voip--phone-menu_item-action_transfer',
    onClick: onTransferConsult
  }, "Transferir")) : agent.name);
};

/**
 * Transfer menu queue button component.
 */

var TransferMenuQueueButton = function TransferMenuQueueButton(_ref) {
  var queue = _ref.queue,
      disabled = _ref.disabled,
      consultActive = _ref.consultActive,
      onConsult = _ref.onConsult,
      onCancelConsult = _ref.onCancelConsult,
      onTransferConsult = _ref.onTransferConsult;

  /* Resolves class names */
  var className = useMemo(function () {
    var classes = ['voip--phone-menu_item'];

    if (disabled && !consultActive) {
      classes.push('voip--phone-menu_item-disabled');
    }

    if (consultActive) {
      classes.push('voip--phone-menu_item-consult_active');
    }

    return classes.join(' ');
  }, [disabled, consultActive]);
  /**
   * Starts a consulting a queue on click.
   */

  var handleConsultClick = useCallback(function () {
    if (consultActive || disabled) {
      return;
    }

    onConsult(queue.id);
  }, [queue, disabled, consultActive, onConsult]);
  return React.createElement("div", {
    className: className,
    onClick: handleConsultClick
  }, consultActive ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'voip--phone-menu_item-action_cancel',
    onClick: onCancelConsult
  }, "Cancelar"), React.createElement("div", {
    className: 'voip--phone-menu_item-action_transfer',
    onClick: onTransferConsult
  }, "Transferir")) : queue.name);
};

var TransferMenu = function TransferMenu() {
  /* Phone context */
  var _usePhoneContext = usePhoneContext(),
      transferMenu = _usePhoneContext.transferMenu,
      agentsAvailable = _usePhoneContext.agentsAvailable,
      queuesAvailable = _usePhoneContext.queuesAvailable,
      consultedAgentId = _usePhoneContext.consultedAgentId,
      consultedQueueId = _usePhoneContext.consultedQueueId,
      onConsult = _usePhoneContext.onConsult,
      loading = _usePhoneContext.loading,
      handleConsultAgent = _usePhoneContext.handleConsultAgent,
      handleConsultQueue = _usePhoneContext.handleConsultQueue,
      handleTransferCall = _usePhoneContext.handleTransferCall,
      handleCancelConsult = _usePhoneContext.handleCancelConsult;
  /* UI Loading state */


  return React.createElement(React.Fragment, null, transferMenu && React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'voip--phone-transfer_menu'
  }, loading.transferList ? React.createElement("div", {
    className: 'voip--phone-transfer_menu_header'
  }, "Carregando...") : React.createElement(React.Fragment, null, React.createElement("div", {
    className: 'voip--phone-transfer_menu_header'
  }, "Agentes dispon\xEDveis"), agentsAvailable.map(function (agent) {
    return React.createElement(TransferMenuAgentButton, {
      key: agent.id,
      agent: agent,
      disabled: onConsult && agent.id !== consultedAgentId || onConsult && Boolean(consultedQueueId) || loading.consulting,
      consultActive: !consultedQueueId && agent.id === consultedAgentId,
      onConsult: handleConsultAgent,
      onCancelConsult: handleCancelConsult,
      onTransferConsult: handleTransferCall
    });
  }), React.createElement("div", {
    className: 'voip--phone-transfer_menu_header'
  }, "Filas dispon\xEDveis"), queuesAvailable.map(function (queue) {
    return React.createElement(TransferMenuQueueButton, {
      key: queue.id,
      queue: queue,
      disabled: onConsult && queue.id !== consultedQueueId || loading.consulting,
      consultActive: queue.id === consultedQueueId,
      onConsult: handleConsultQueue,
      onCancelConsult: handleCancelConsult,
      onTransferConsult: handleTransferCall
    });
  })))));
};

var WorkBreakMenu = function WorkBreakMenu() {
  /* Phone context */
  var _usePhoneContext = usePhoneContext(),
      loading = _usePhoneContext.loading,
      workBreakMenu = _usePhoneContext.workBreakMenu,
      workBreaksAvailable = _usePhoneContext.workBreaksAvailable,
      workBreaksLimitReachedIds = _usePhoneContext.workBreaksLimitReachedIds,
      handleEnterWorkBreak = _usePhoneContext.handleEnterWorkBreak;

  if (!workBreakMenu) return null;
  /* Loading... */

  if (loading.workBreakList) {
    return React.createElement("div", {
      className: "voip--phone-workBreak_menu"
    }, React.createElement("div", {
      className: "voip--phone-workBreak_menu_header"
    }, "Carregando..."));
  }
  /* No work breaks in the campaign */


  if (workBreaksAvailable.length === 0) {
    React.createElement("div", {
      className: "voip--phone-workBreak_menu"
    }, React.createElement("div", {
      className: "voip--phone-workBreak_menu_header"
    }, "Nenhum intervalo na campanha"));
  }

  return React.createElement("div", {
    className: "voip--phone-workBreak_menu"
  }, React.createElement("div", {
    className: "voip--phone-workBreak_menu_header"
  }, "Intervalos dispon\xEDveis"), workBreaksAvailable.map(function (workBreak) {
    var limitReached = workBreaksLimitReachedIds.includes(workBreak.id);
    console.log({
      limitReached: limitReached,
      workBreaksLimitReachedIds: workBreaksLimitReachedIds
    });

    if (limitReached) {
      return React.createElement("div", {
        key: workBreak.id,
        className: "voip--phone-menu_item"
      }, workBreak.name, " - Limite atingido");
    }

    return React.createElement("div", {
      key: workBreak.id,
      className: "voip--phone-menu_item",
      onClick: handleEnterWorkBreak(workBreak.id)
    }, workBreak.name);
  }));
};

/**
 * Phone menu component.
 */

var Menu = function Menu() {
  /* Voip context */
  var _useVoipContext = useVoipContext(),
      agentStatus = _useVoipContext.agentStatus;
  /* Phone context */


  var _usePhoneContext = usePhoneContext(),
      menu = _usePhoneContext.menu,
      onCall = _usePhoneContext.onCall,
      loading = _usePhoneContext.loading,
      handleLoginAgent = _usePhoneContext.handleLoginAgent,
      handleLogoutAgent = _usePhoneContext.handleLogoutAgent,
      handleToggleTransferMenu = _usePhoneContext.handleToggleTransferMenu,
      handleQualifyCall = _usePhoneContext.handleQualifyCall,
      handleListWorkBreaks = _usePhoneContext.handleListWorkBreaks,
      handleExitWorkBreak = _usePhoneContext.handleExitWorkBreak;
  /* Resolves the menu style classes */


  var className = useMemo(function () {
    var classes = ['voip--phone-menu'];

    if (menu) {
      classes.push('voip--phone-menu-open');
    }

    return classes.join(' ');
  }, [menu]);
  return React.createElement("div", {
    className: className
  }, React.createElement(MenuButton, {
    loading: false,
    disabled: !onCall || agentStatus.status === AGENT_STATUS.ACW,
    onClick: handleToggleTransferMenu
  }, "Transferir chamada"), React.createElement(MenuButton, {
    loading: loading.acw,
    disabled: agentStatus.status !== AGENT_STATUS.ACW,
    onClick: handleQualifyCall
  }, "Encerrar p\xF3s atendimento"), agentStatus.status === AGENT_STATUS.AGENT_BREAK ? React.createElement(MenuButton, {
    loading: false,
    disabled: false,
    onClick: handleExitWorkBreak
  }, "Encerrar pausa") : React.createElement(MenuButton, {
    loading: loading.workBreakList,
    disabled: onCall || agentStatus.status === AGENT_STATUS.DISCONNECTED,
    onClick: handleListWorkBreaks
  }, "Entrar em pausa"), agentStatus.status === AGENT_STATUS.DISCONNECTED ? React.createElement(MenuButton, {
    loading: loading.auth,
    onClick: handleLoginAgent
  }, "Entrar") : React.createElement(MenuButton, {
    disabled: onCall,
    loading: loading.auth,
    onClick: handleLogoutAgent
  }, "Sair"), React.createElement(TransferMenu, null), React.createElement(WorkBreakMenu, null));
};

var Timer = function Timer() {
  var _useVoipContext = useVoipContext(),
      voipSocket = _useVoipContext.voipSocket;
  /* Interval pointer */


  var intervalId;
  /* Holds the time value in seconds */

  var _useState = useState(0),
      time = _useState[0],
      setTime = _useState[1];
  /* Time normalized */


  var timeNormalized = useMemo(function () {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;
    var parsedMinutes = minutes.toString().padStart(2, '0');
    var parsedSeconds = seconds.toString().padStart(2, '0');
    return parsedMinutes + ":" + parsedSeconds;
  }, [time]);
  /* Handles interval */

  useEffect(function () {
    if (!voipSocket) {
      return;
    }

    var clearTimerInterval = function clearTimerInterval() {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
    /* Starts timer */


    intervalId = setInterval(function () {
      setTime(function (state) {
        return state + 1;
      });
    }, 1000);
    voipSocket.on('call-was-finished', clearTimerInterval);
    return function () {
      clearTimerInterval();
      voipSocket.off('call-was-finished', clearTimerInterval);
    };
  }, [voipSocket]);
  return React.createElement("div", null, timeNormalized);
};

/**
 * Countdown component.
 */

var Countdown = function Countdown(_ref) {
  var seconds = _ref.seconds;

  /* Interval pointer */
  var intervalId;
  /* Holds the value of the countdown timer */

  var _useState = useState(seconds),
      value = _useState[0],
      setValue = _useState[1];
  /* Handles countdown interval */


  useEffect(function () {
    /* Starts countdown */
    intervalId = setInterval(function () {
      setValue(function (state) {
        if (state === 0) {
          return state;
        }

        return state - 1;
      });
    }, 1000);
    return function () {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);
  return React.createElement("div", null, value, "s");
};

/**
 * Phone header component.
 */

var Header = function Header(_ref) {
  var campaignName = _ref.campaignName,
      _ref$showDetailedStat = _ref.showDetailedStatus,
      showDetailedStatus = _ref$showDetailedStat === void 0 ? false : _ref$showDetailedStat;

  /* Voip context */
  var _useVoipContext = useVoipContext(),
      agentStatus = _useVoipContext.agentStatus,
      callStatus = _useVoipContext.callStatus,
      sipError = _useVoipContext.sipError;
  /* Phone context */


  var _usePhoneContext = usePhoneContext(),
      onCall = _usePhoneContext.onCall,
      loading = _usePhoneContext.loading,
      consulting = _usePhoneContext.consulting,
      handleHangupCall = _usePhoneContext.handleHangupCall,
      handleTogglePhone = _usePhoneContext.handleTogglePhone;
  /* Resolves header class names */


  var className = useMemo(function () {
    var classes = ['voip--phone-header'];

    if (sipError) {
      classes.push('voip--phone-header-error');
    }

    if (onCall || consulting) {
      classes.push('voip--phone-header-on_call');
    }

    return classes.join(' ');
  }, [onCall, consulting, sipError]);
  /* Resolves header label */

  var label = useMemo(function () {
    if (sipError) {
      return 'Erro, a página será recarregada...';
    }

    if (agentStatus.status === AGENT_STATUS.DISCONNECTED) {
      return 'Agente desconectado';
    }

    if (agentStatus.status === AGENT_STATUS.ACW) {
      return 'Pós atendimento';
    }

    if (agentStatus.status === AGENT_STATUS.MANUAL) {
      return 'Manual';
    }

    if (loading.calling) {
      return 'Ligando...';
    }

    if (consulting) {
      return 'Em transferência';
    }

    if (onCall) {
      return 'Em ligação';
    }

    if (callStatus.status === CALL_STATUS.ON_HOLD) {
      return 'Em espera';
    }

    if (agentStatus.status === AGENT_STATUS.IDLE) {
      return "Dispon\xEDvel - " + campaignName;
    }

    return;
  }, [agentStatus.status, callStatus.status, loading.calling, onCall, consulting, sipError, campaignName]);
  /**
   * Hangup call function wrapper to stop event propagation.
   *
   * @param {React.MouseEvent<HTMLDivElement, MouseEvent>} event Default react mouse event.
   */

  var hangupCallWrapper = function hangupCallWrapper(event) {
    event.stopPropagation();
    handleHangupCall();
  };

  return React.createElement("div", {
    className: className,
    onClick: handleTogglePhone
  }, showDetailedStatus ?
  /* Development porpouse */
  React.createElement(React.Fragment, null, React.createElement("div", null, "Agente: ", agentStatus.label), React.createElement("div", null, "Chamada: ", callStatus.label)) :
  /* Production */
  React.createElement(React.Fragment, null, label || agentStatus.label, sipError && React.createElement(Countdown, {
    seconds: 60
  }), onCall && React.createElement("div", {
    className: 'voip--phone-header-icon'
  }, React.createElement(Timer, null), React.createElement("div", {
    onClick: hangupCallWrapper
  }, React.createElement(FaPhone, {
    color: 'red'
  })))));
};

/**
 * Single key button.
 */

var KeyButton = function KeyButton(_ref) {
  var number = _ref.number,
      disabled = _ref.disabled,
      onClick = _ref.onClick;

  /* Resolves key button class names */
  var className = useMemo(function () {
    var classes = ['voip--phone-number'];

    if (disabled) {
      classes.push('voip--phone-number-disabled');
    }

    return classes.join(' ');
  }, [disabled]);
  /* Handle number click */

  var handleClick = useCallback(function () {
    if (disabled) {
      return;
    }

    onClick(number);
  }, [number, disabled]);
  return React.createElement("div", {
    className: className,
    onClick: handleClick
  }, number);
};

/**
 * Keypad wrapper component.
 */

var Keypad = function Keypad() {
  /* Voip context */
  var _useVoipContext = useVoipContext(),
      agentStatus = _useVoipContext.agentStatus;
  /* Phone context */


  var _usePhoneContext = usePhoneContext(),
      onCall = _usePhoneContext.onCall,
      loading = _usePhoneContext.loading,
      handleToggleMenu = _usePhoneContext.handleToggleMenu,
      handleKeyNumberPress = _usePhoneContext.handleKeyNumberPress,
      handleStartManualCall = _usePhoneContext.handleStartManualCall,
      handleHangupCall = _usePhoneContext.handleHangupCall;
  /* Resolves if the keys can be pressed */


  var keysDisabled = useMemo(function () {
    return onCall || loading.calling || agentStatus.status === AGENT_STATUS.DISCONNECTED || agentStatus.status === AGENT_STATUS.AGENT_BREAK;
  }, [onCall, loading.calling, agentStatus.status]);
  return React.createElement("div", {
    className: "voip--phone-keypad"
  }, React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 1,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 2,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 3,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 4,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 5,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 6,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 7,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 8,
    onClick: handleKeyNumberPress
  }), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 9,
    onClick: handleKeyNumberPress
  }), React.createElement("div", {
    onClick: handleToggleMenu,
    className: "voip--phone-number"
  }, React.createElement(FaBars, null)), React.createElement(KeyButton, {
    disabled: keysDisabled,
    number: 0,
    onClick: handleKeyNumberPress
  }), onCall ? React.createElement("div", {
    onClick: handleHangupCall,
    className: "voip--phone-number " + (loading.hangingUp || agentStatus.status === AGENT_STATUS.ACW ? 'voip--phone-number-disabled' : '')
  }, React.createElement(FaPhone, {
    color: "red"
  })) : React.createElement("div", {
    onClick: handleStartManualCall,
    className: "voip--phone-number " + (keysDisabled ? 'voip--phone-number-disabled' : '')
  }, React.createElement(FaPhone, {
    color: "green"
  })));
};

/**
 * Number display component.
 */

var NumberDisplay = function NumberDisplay() {
  var _usePhoneContext = usePhoneContext(),
      onCall = _usePhoneContext.onCall,
      value = _usePhoneContext.value,
      isCellphone = _usePhoneContext.isCellphone,
      setFocus = _usePhoneContext.setFocus,
      handlePasteNumber = _usePhoneContext.handlePasteNumber,
      handleEraseNumber = _usePhoneContext.handleEraseNumber;
  /* Number display mask */


  var mask = useMemo(function () {
    if (isCellphone) {
      return '(99) 99999-9999';
    }

    return '(99) 9999-99999';
  }, [isCellphone]);
  /* Icon color */

  var iconColor = useMemo(function () {
    if (value.length === 0) {
      return 'rgba(0, 0, 0, 0.4)';
    }

    return 'rgba(0, 0, 0, 0.8)';
  }, [value]);
  /* Copy number to clipboard */

  var copyToClipboard = useCallback(function () {
    if (!navigator) {
      return;
    }

    navigator.clipboard.writeText(value.toString());
  }, [value]);
  return React.createElement("div", {
    className: 'voip--phone-number_display'
  }, React.createElement(InputMask, {
    readOnly: true,
    value: value,
    mask: mask,
    maskChar: null,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    }
  }), onCall ? React.createElement(FaCopy, {
    size: 24,
    color: iconColor,
    onClick: copyToClipboard,
    className: 'voip--phone-number_display_icon'
  }) : React.createElement(React.Fragment, null, React.createElement(FaPaste, {
    size: 24,
    color: 'rgba(0, 0, 0, 0.8)',
    onClick: handlePasteNumber,
    className: 'voip--phone-number_display_icon',
    style: {
      right: 'calc(var(--defaultPadding) * 3)'
    }
  }), React.createElement(FaBackspace, {
    size: 24,
    color: iconColor,
    onClick: handleEraseNumber,
    className: 'voip--phone-number_display_icon'
  })));
};

var Phone = function Phone() {
  /* Phone context */
  var _usePhoneContext = usePhoneContext(),
      open = _usePhoneContext.open,
      campaignName = _usePhoneContext.campaignName,
      callId = _usePhoneContext.callId;
  /* Resolves phone element class names */


  var className = useMemo(function () {
    var classes = ['voip--phone'];

    if (open) {
      classes.push('voip--phone-open');
    }

    if (callId) {
      classes.push('voip--phone-on_call');
    }

    return classes.join(' ');
  }, [open, callId]);
  return React.createElement("div", {
    className: className
  }, React.createElement(Header, {
    campaignName: campaignName
  }), React.createElement(NumberDisplay, null), React.createElement(Keypad, null), React.createElement(Menu, null));
};

var phone = (function (props) {
  return React.createElement(PhoneProvider, null, React.createElement(Phone, Object.assign({}, props)));
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/* Local style variables */\n.voip--phone {\n  --fontSize: 16px;\n  --defaultSize: 16px;\n  --defaultPadding: 16px;\n\n  --phoneWidth: calc(var(--defaultSize) * 16);\n  --menuWidth: var(--phoneWidth);\n  --transferMenuWidth: var(--menuWidth);\n  --headerHeight: calc(var(--defaultSize) * 4);\n  --numberHeight: calc(var(--defaultSize) * 3);\n  --numberDisplayHeight: calc(var(--defaultSize) * 3);\n\n  --primaryColor: hsl(258, 94%, 61%);\n  --secondaryColor: hsl(193, 95%, 48%);\n  --borderColor: hsl(210, 10%, 90%);\n  --hoverColor: hsl(210, 20%, 90%);\n  --disabledColor: hsl(210, 20%, 80%);\n  --backgroundColor: hsl(0, 0%, 100%);\n}\n\n/* Components styles */\n.voip--phone {\n  position: fixed;\n  bottom: 0;\n  right: calc(var(--defaultPadding) * 2);\n\n  width: var(--phoneWidth);\n\n  border: 1px solid var(--borderColor);\n\n  font-size: var(--fontSize);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n\n  transform: translate3d(0, calc(100% - var(--headerHeight)), 0);\n  transition: transform 200ms ease-in-out;\n\n  background-color: var(--backgroundColor);\n}\n\n.voip--phone.voip--phone-open {\n  transform: translate3d(0, 0, 0);\n}\n\n.voip--phone.voip--phone-on_call {\n  transform: translate3d(\n    0,\n    calc(100% - var(--headerHeight) - var(--numberDisplayHeight)),\n    0\n  );\n}\n\n.voip--phone.voip--phone-open.voip--phone-on_call {\n  transform: translate3d(0, 0, 0);\n}\n\n.voip--phone-header {\n  position: relative;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n\n  padding: 0 var(--fontSize);\n\n  height: var(--headerHeight);\n\n  color: #fff;\n  background-color: var(--primaryColor);\n\n  cursor: pointer;\n}\n\n.voip--phone-header.voip--phone-header-error {\n  background-color: red;\n}\n\n.voip--phone-header .voip--phone-header-icon {\n  position: absolute;\n  top: 24px;\n  right: var(--defaultPadding);\n\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  -moz-column-gap: var(--defaultPadding);\n       column-gap: var(--defaultPadding);\n}\n\n.voip--phone-header.voip--phone-header-on_call {\n  background-color: var(--secondaryColor);\n}\n\n.voip--phone-number_display {\n  position: relative;\n}\n\n.voip--phone-number_display input {\n  width: 100%;\n  height: var(--numberDisplayHeight);\n\n  border: 0;\n  outline: none;\n\n  padding: 0 var(--defaultPadding);\n\n  font-size: var(--fontSize);\n}\n\n.voip--phone-number_display_icon {\n  position: absolute;\n  top: 12px;\n  right: var(--defaultPadding);\n\n  cursor: pointer;\n}\n\n.voip--phone-keypad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-auto-rows: var(--numberHeight);\n}\n\n.voip--phone-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-weight: bold;\n\n  border: 1px solid var(--borderColor);\n  border-bottom: 0;\n\n  cursor: pointer;\n}\n\n.voip--phone-number:nth-child(3n),\n.voip--phone-number:nth-child(3n - 2) {\n  border-right: 0;\n  border-left: 0;\n}\n\n.voip--phone-menu {\n  position: absolute;\n  bottom: 0;\n  right: var(--phoneWidth);\n\n  width: var(--menuWidth);\n\n  border: 1px solid var(--borderColor);\n  border-bottom: 0;\n  border-right: 0;\n\n  background-color: var(--backgroundColor);\n\n  transform: translate3d(0, 110%, 0);\n\n  transition: transform 200ms ease-in-out;\n}\n\n.voip--phone-menu.voip--phone-menu-open {\n  transform: translate3d(0, 0, 0);\n}\n\n.voip--phone-menu_item:last-child {\n  border-bottom: 0;\n}\n\n.voip--phone-menu_item:hover,\n.voip--phone-number:hover {\n  background-color: var(--hoverColor);\n}\n\n.voip--phone-menu_item.voip--phone-menu_item-disabled,\n.voip--phone-number.voip--phone-number-disabled {\n  color: var(--hoverColor);\n  background-color: var(--disabledColor);\n\n  cursor: not-allowed;\n}\n\n.voip--phone-transfer_menu,\n.voip--phone-workBreak_menu {\n  position: absolute;\n  bottom: 0;\n  right: calc(var(--menuWidth) + 1px);\n\n  width: var(--transferMenuWidth);\n\n  border: 1px solid var(--borderColor);\n  border-bottom: 0;\n\n  background-color: var(--backgroundColor);\n}\n\n.voip--phone-transfer_menu_header,\n.voip--phone-workBreak_menu_header,\n.voip--phone-menu_item {\n  display: flex;\n  align-items: center;\n  padding: 0 var(--defaultPadding);\n\n  height: calc(var(--numberHeight) - 1px);\n\n  border-bottom: 1px solid var(--borderColor);\n}\n\n.voip--phone-transfer_menu_header,\n.voip--phone-workBreak_menu_header {\n  font-weight: bold;\n}\n\n.voip--phone-menu_item {\n  cursor: pointer;\n}\n\n.voip--phone-menu_item-action_cancel,\n.voip--phone-menu_item-action_transfer {\n  flex: 1;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 100%;\n\n  color: var(--backgroundColor);\n}\n\n.voip--phone-menu_item-consult_active {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.voip--phone-menu_item-action_transfer {\n  background-color: green;\n}\n\n.voip--phone-menu_item-action_cancel {\n  background-color: red;\n}\n";
styleInject(css_248z);

export { phone as Phone, VoipContext, Provider as VoipProvider, useVoipContext };
//# sourceMappingURL=monest-3cplus-socket.esm.js.map
